exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".full-height[data-v-7c4b0101]{height:100vh}.flex-center[data-v-7c4b0101]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.position-ref[data-v-7c4b0101]{position:relative}.top-right[data-v-7c4b0101]{position:absolute;right:10px;top:18px}.content[data-v-7c4b0101]{text-align:center}.title[data-v-7c4b0101]{font-size:60px}.links>a[data-v-7c4b0101]{color:#636b6f;padding:0 25px;font-size:12px;font-weight:600;letter-spacing:.1rem;text-decoration:none;text-transform:uppercase}.m-b-md[data-v-7c4b0101]{margin-bottom:30px;color:#000}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7c4b0101","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/pages/auth/adminlogin.vue
// module id = 6wsa
// module chunks = 0